<template>
  <div class="chart-wrapper">
    <div class="chart-content" :class="{blurred: isFetching}">
      <slot></slot>
    </div>
    <transition name="fade">
      <div v-if="isFetching" class="loader"><div class="text">Cargando evolutivo...</div></div>
    </transition>
    <transition name="fade">
      <div class="no-data" v-if="!isFetching && !hasData"> 
        <div class="text">{{t('no_data_for_ind')}}</div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props:{
    status: Object
  },
  computed: {
    isFetching(){
      return this.status && this.status.status === 'fetching'
    },
    hasData () {
      return this.status && this.status.status === 'ready'
    }
  },
}
</script>

<style scoped lang="stylus">
.chart-wrapper
  // border solid 1px #f0a
  position relative
  display flex
  flex-direction column
  .chart-content
    flex: 1 1 100%;
  .loader,.no-data
    width calc(100% + 1px) //Chapuzilla para el ValueBar...
    height 100%
    position absolute
    font-family 'Lato'
    top 0px
    left 0px
    background: rgba(255,255,255,0.8)
    .text
      color #666
      position absolute
      top 50%;
      left 50%
      white-space nowrap
      transform translate(-50%,-50%)
  .fade-enter-active, .fade-leave-active 
    transition opacity .3s
    // overflow hidden
  .fade-enter, .fade-leave-to
    opacity 0
    
  .no-data
    .text
      text-align: center;
      white-space normal
</style>